import { ref } from 'vue'

export default function useRoundHallPlacePosition({ row, placeKey }) {
  const float = ref('')
  const marginRight = ref(0)
  const marginLeft = ref(0)

  if (Number(row.value) > 8) {
    if (Number(placeKey.value) < 40) {
      float.value = 'left'
    } else {
      float.value = 'right'
    }
  }
  if (Number(row.value) === 10 && Number(placeKey.value) === 53) {
    marginRight.value = 96
  }
  if (Number(row.value) === 8 && Number(placeKey.value) === 47) {
    marginRight.value = 34
    float.value = 'right'
  }
  if (Number(row.value) === 7 && Number(placeKey.value) === 7) {
    marginLeft.value = 68
    float.value = 'left'
  }
  if (Number(row.value) === 7 && Number(placeKey.value) === 52) {
    float.value = 'right'
    marginRight.value = 34
  }
  if (Number(row.value) === 7 && Number(placeKey.value) === 46) {
    float.value = 'right'
  }
  if (Number(row.value) === 6 && Number(placeKey.value) < 30) {
    float.value = 'left'
  }
  if (Number(row.value) === 6 && Number(placeKey.value) > 20) {
    float.value = 'right'
  }
  if (Number(row.value) === 6 && Number(placeKey.value) === 12) {
    marginLeft.value = 68
  }
  if (Number(row.value) === 6 && Number(placeKey.value) === 51) {
    marginRight.value = 68
  }
  if (Number(row.value) === 5 && Number(placeKey.value) < 30) {
    float.value = 'left'
  }
  if (Number(row.value) === 5 && Number(placeKey.value) > 20) {
    float.value = 'right'
  }
  if (Number(row.value) === 5 && Number(placeKey.value) === 11) {
    marginLeft.value = 102
  }
  if (Number(row.value) === 5 && Number(placeKey.value) === 50) {
    marginRight.value = 102
  }
  if (Number(row.value) === 4 && Number(placeKey.value) <= 10) {
    float.value = 'left'
  }
  if (Number(row.value) === 4 && Number(placeKey.value) > 10) {
    float.value = 'right'
  }
  if (Number(row.value) === 4 && Number(placeKey.value) === 10) {
    marginLeft.value = 136
  }
  if (Number(row.value) === 4 && Number(placeKey.value) === 49) {
    marginRight.value = 136
  }
  if (Number(row.value) === 3 && Number(placeKey.value) < 10) {
    float.value = 'left'
  }
  if (Number(row.value) === 3 && Number(placeKey.value) > 10) {
    float.value = 'right'
  }
  if (Number(row.value) === 3 && Number(placeKey.value) === 9) {
    marginLeft.value = 170
  }
  if (Number(row.value) === 3 && Number(placeKey.value) === 48) {
    marginRight.value = 170
  }
  if (Number(row.value) === 2 && Number(placeKey.value) === 8) {
    float.value = 'left'
    marginLeft.value = 204
  }
  if (Number(row.value) === 2 && Number(placeKey.value) === 2) {
    float.value = 'left'
  }
  if (Number(row.value) === 2 && Number(placeKey.value) === 41) {
    float.value = 'right'
  }
  if (Number(row.value) === 2 && Number(placeKey.value) === 41) {
    marginRight.value = 238
  }
  if (Number(row.value) === 1 && Number(placeKey.value) === 1) {
    float.value = 'left'
    marginLeft.value = 272
  }
  if (Number(row.value) === 1 && Number(placeKey.value) === 40) {
    float.value = 'right'
    marginRight.value = 272
  }

  return { float, marginLeft, marginRight }
}
